import { useMemo } from 'react';
import { useCompanyTypeIsValid } from '../../features/company-type/stores/company-type-store';
import { useYourDetailsIsValid } from '../../features/your-details/stores/your-details.store';
import { useCompanyDetailsIsValid } from '../../features/company-details/stores/company-details.store';
import { useUploadDocumentsIsValid } from '../../features/upload-documents/stores/upload-documents.store';
import { useProjectDetailsIsValid } from '../../features/project-details/stores/project-details.store';
import { useServiceNeedsIsValid } from '../../features/service-needs/stores/service-needs-store';

export function useStepValidation() {
  const isCompanyTypeValid = useCompanyTypeIsValid();
  const isYourDetailsValid = useYourDetailsIsValid();
  const isCompanyDetailsValid = useCompanyDetailsIsValid();
  const isUploadDocumentsValid = useUploadDocumentsIsValid();
  const isProjectDetailsValid = useProjectDetailsIsValid();
  const isServiceNeedsValid = useServiceNeedsIsValid();

  const stepValidation = useMemo(
    () => ({
      '/service-needs': isServiceNeedsValid,
      '/': isCompanyTypeValid,
      '/your-details': isYourDetailsValid,
      '/upload-documents': isUploadDocumentsValid,
      '/company-details': isCompanyDetailsValid,
      '/project-details': isProjectDetailsValid,
    }),
    [
      isCompanyTypeValid,
      isYourDetailsValid,
      isUploadDocumentsValid,
      isCompanyDetailsValid,
      isProjectDetailsValid,
      isServiceNeedsValid,
    ]
  );

  return { stepValidation };
}
